/**
 * Utility per la gestione e formattazione delle date
 */

/**
 * Formatta una data in formato stringa leggibile in italiano (GG/MM/AAAA)
 * @param {Date|string|number} date - La data da formattare (oggetto Date, timestamp o stringa ISO)
 * @returns {string} Data formattata come GG/MM/AAAA
 */
export const formatDate = (date) => {
  if (!date) return '';
  
  try {
    const dateObj = new Date(date);
    
    if (isNaN(dateObj.getTime())) {
      return '';
    }
    
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error('Errore nella formattazione della data:', error);
    return '';
  }
};

/**
 * Formatta una data in formato data e ora (GG/MM/AAAA HH:MM)
 * @param {Date|string|number} date - La data da formattare (oggetto Date, timestamp o stringa ISO)
 * @returns {string} Data formattata come GG/MM/AAAA HH:MM
 */
export const formatDateTime = (date) => {
  if (!date) return '';
  
  try {
    const dateObj = new Date(date);
    
    if (isNaN(dateObj.getTime())) {
      return '';
    }
    
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } catch (error) {
    console.error('Errore nella formattazione della data e ora:', error);
    return '';
  }
};

/**
 * Calcola la differenza in giorni tra due date
 * @param {Date|string|number} dateStart - La data di inizio
 * @param {Date|string|number} dateEnd - La data di fine
 * @returns {number} Differenza in giorni tra le date
 */
export const daysBetween = (dateStart, dateEnd) => {
  if (!dateStart || !dateEnd) return 0;
  
  try {
    const start = new Date(dateStart);
    const end = new Date(dateEnd);
    
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return 0;
    }
    
    // Reset alle ore 00:00 per calcolare solo i giorni completi
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    
    // Calcola la differenza in millisecondi e converti in giorni
    const diffTime = Math.abs(end - start);
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
  } catch (error) {
    console.error('Errore nel calcolo dei giorni tra due date:', error);
    return 0;
  }
};
